module.exports = __webpack_public_path__ + "static/media/F3.020aecb8.jpg";